var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 168,
    viewBox: "0 0 169 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1923 53.9812H5.39168C3.89155 53.9812 2.67603 55.1973 2.67603 56.6969V165.284C2.67603 166.784 3.89155 167.999 5.39168 167.999H39.1923C40.6924 167.999 41.908 166.784 41.908 165.284V56.6969C41.908 55.1973 40.6924 53.9812 39.1923 53.9812Z",
    fill: "#9A031E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3042 0C10.0055 0 0 9.99469 0 22.2797C0 34.5702 10.0055 44.5687 22.3042 44.5687C34.5931 44.5687 44.5905 34.5697 44.5905 22.2797C44.591 9.99469 34.5931 0 22.3042 0Z",
    fill: "#9A031E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.167 51.2825C111.591 51.2825 101.556 57.1184 95.4687 63.7495V56.6969C95.4687 55.1974 94.2532 53.9813 92.7531 53.9813H60.3831C58.8829 53.9813 57.6674 55.1974 57.6674 56.6969V165.284C57.6674 166.784 58.8829 168 60.3831 168H94.1098C95.61 168 96.8255 166.784 96.8255 165.284V111.559C96.8255 93.4544 101.743 86.4013 114.363 86.4013C128.108 86.4013 129.2 97.7082 129.2 112.49V165.284C129.2 166.785 130.415 168 131.916 168H165.655C167.155 168 168.37 166.785 168.37 165.284V105.723C168.37 78.8023 163.237 51.2825 125.167 51.2825Z",
    fill: "#9A031E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin_logo.f077e8a63d6e0afced6f4a8214375b9f.svg";
export { ForwardRef as ReactComponent };